/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate
     */
    useScheduleDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate
     */
    subsidyPriceId?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate {
    return JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'useScheduleDateTime': !exists(json, 'useScheduleDateTime') ? undefined : json['useScheduleDateTime'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'subsidyPriceId': !exists(json, 'subsidyPriceId') ? undefined : json['subsidyPriceId'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'useScheduleDateTime': value.useScheduleDateTime,
        'price': value.price,
        'subsidyPriceId': value.subsidyPriceId,
    };
}

